<template>
  <section class="container Section Section--creativeServices">
    <div class="row">

      <div class="col-lg-6" style="z-index: 1;">
        <app-slider :id="'creativeServices'" :imageLs="imageLs" :classes="[ 'Intrinsic-wrapper--5x4', 'Reveal' ]"/>
      </div>

      
      <app-card :classes="['col-lg-6', 'mt-4', 'mt-lg-0', 'ml-auto', 'Reveal']">
        <h3 class="Card-title" slot="Card-title">
          Unique Software for Your Event
        </h3>
        <p class="mt-5" slot="Card-body">
          Ideum's Creative Services team can be contracted to help you develop a unique custom application for your event. Ideum has deep experience in interaction design, tangible user interface design, and multitouch / multiuser installations. We have a diverse range of design experience and can work with budgets of varying sizes. We work regularly with world-class museums, Fortune 500 companies, nonprofits, and government agencies to create compelling interactive experiences.
        </p>
        <footer slot="Card-button">
          <a 
            class="Button Button--emerald mt-4"
            target="_blank" 
            href="http://ideum.com/work"
            title="Learn more about Ideum's Creative Services"
            rel="noopener">
            <span class="Button-text">Explore Creative Services</span>
          </a>
        </footer>
      </app-card>

    </div>
  </section>
</template>

<script>
import projects from './../../static/data/projects.json'
import appCard from './Card'
import appSlider from './Slider'
export default {
  components: {
    appCard,
    appSlider
  },

  data () {
    return {
      projects
    }
  },

  computed: {
    imageLs () {
      const imageLs = []
      imageLs.push(this.projects.images)
      return imageLs
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Section--creativeServices {
  margin-top: 8em;
  @media screen and (max-width: $grid-sm) {
    margin-top: 4em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CreativeServices.vue